import React from 'react';
import PropTypes from 'prop-types';

const RuleOfConduct = ({alt = '', icon, text}) => (
    <div style={styles.container}>
        <img src={icon} alt={alt} style={{ width: '120px'}}/>
        <div style={styles.text}>
            {text}
        </div>
    </div>
);

RuleOfConduct.propTypes = {
    alt: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};


const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '15px',
    },
    text: {
        color: '003d4c',
        fontFamily: 'Ubuntu',
        fontWeight: 500,
        fontSize: '18px',
        marginLeft: '30px',
    },
}

export default RuleOfConduct;
